import {Renderer} from './render.js';
import {RefugeScenery} from './refuge-scenery.js';

const clamp=(n,a=0,b=1)=>Math.max(a,Math.min(b,n));
const ease=n=>{n=clamp(n);return n*n*(3-2*n);};
const lerp=(a,b,t)=>a+(b-a)*t;

// The refuge is staged as one physical scene: the passenger walks into the
// cage, the cage carries him, and the shaft foreground occludes his descent.
export class CaveScene{
  constructor(canvas){
    this.canvas=canvas;this.r=new Renderer(canvas);this.r.worldId=0;
    this.scenery=new RefugeScenery();this.time=0;this.rescued=false;this.rescueTime=null;
    this.stub={wind:0,top:{getAngularVelocity:()=>0}};
  }
  resize(){this.r.resize();this.scenery.reset();}
  enter(rescued=false){this.time=0;this.rescued=rescued;this.rescueTime=rescued?99:null;}
  setRescued(value){
    value=!!value;
    if(value&&!this.rescued)this.rescueTime=0;
    if(!value)this.rescueTime=null;
    this.rescued=value;
  }
  person(x,feet,unit,{old=false,sit=0,walk=1,look=0,facing=1,bend=0}={}){
    const r=this.r,c=r.ctx;
    c.save();
    if(old)c.filter='grayscale(.72) brightness(.68) sepia(.22)';
    r.figure.draw(this.stub,0,{q:{x,y:feet},unit,a:0,phase:walk,landing:0,harness:{x,y:feet-unit*30},fall:0,facing,
      performance:{sit,bend,look,old,walking:walk<.99}});
    c.restore();
  }
  draw(dt=0){
    const r=this.r,c=r.ctx,w=r.w,h=r.h;
    this.time+=Math.min(dt,.05);if(this.rescueTime!==null&&this.rescueTime<90)this.rescueTime+=Math.min(dt,.05);
    const t=this.time,rt=this.rescueTime??-1,descent=rt>3.35?ease((rt-3.35)/3.15):rt>90?1:0;
    c.setTransform(r.dpr,0,0,r.dpr,0,0);r.clock=t;
    const l=this.scenery.background(c,w,h,t,descent),u=l.u;

    // The hero enters from the daylight and settles beside the operating line.
    const entrance=ease(t/2.45),heroX=lerp(l.entryX,l.heroX,entrance);
    this.person(heroX,l.floor,u*1.04,{walk:entrance<.99?(t*.95)%1:1,look:-.32*ease((t-2.0)/.9),facing:-1,bend:.04});

    if(!this.rescued){
      const notice=ease((t-2.55)/1.0);
      this.person(l.campX,l.floor,u,{old:true,sit:.76-notice*.24,walk:1,look:.42*notice,facing:1,bend:.28-notice*.12});
      if(t>3.05){c.save();c.globalAlpha=ease((t-3.05)/.4);r.text('?',l.campX+u*22,l.floor-u*65,u*19,'#e8cc8e','center','Georgia',400);c.restore();}
    }else if(rt<6.7){
      const rise=ease(rt/.75),walk=ease((rt-.72)/1.75),board=ease((rt-2.47)/.72);
      const x=lerp(l.campX,l.cageX-u*4,walk),feet=rt<3.35?l.floor:l.cageFloor;
      this.person(x,feet,u,{old:true,sit:.52*(1-rise),walk:walk<.99?(rt*1.45)%1:1,look:lerp(.25,-.1,walk),facing:1,bend:.13*(1-board)});
    }
    this.scenery.foreground(c,l,t);

    // The working shaft adds a warm response without turning the machinery
    // into a glowing fantasy interface.
    if(descent>0&&descent<1){
      c.save();c.globalAlpha=Math.sin(descent*Math.PI)*.28;r.circle(l.shaftX,l.shaftTop+u*22,u*27,'#d8af68');c.restore();
    }
  }
}
